__turbopack_context__.v({
  "injectedContainer": "jJcICW_injectedContainer",
  "pseudoSliderWrapper": "jJcICW_pseudoSliderWrapper",
  "slider": "jJcICW_slider",
  "wrapper": "jJcICW_wrapper",
});
